<template>
  <div class="bookings-daily-list">
    <div v-for="booking in data.bookings">
      <div class="booking-label" :class="booking.type+'-type'">{{ booking.booking_type_label }}</div>
      <div class="booking-title interactive" @click="goToListing(booking)">{{ booking.listing.space_name }}</div>
      <div class="booking-address">{{ booking.listing.address_label }}</div>
      <div class="booking-info-value">{{ booking.sub_total_formatted }}</div>
    </div>
  </div>
</template>

<script>
import BaseModal from '../Base'

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  methods: {
    goToListing(booking) {
      window.open(booking.listing.listing_url, '_blank')
    }
  }
}
</script>
